(function () {
  // ---- CONFIG ----
  var VIEW_ALL_TEXT = 'View&nbsp;Collection&nbsp;&gt;'; // label for view-all link (non-breaking)
  var ADD_VIEW_ALL = true;                      // toggle for view-all link
  var filled = new WeakSet();                   // track ULs already populated

  // Convert to Title Case (first letter of each word uppercase)
  function toTitleCase(str) {
    if (!str) return '';
    return str
      .toLowerCase()
      .replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });
  }

  // Force a list item to behave as a full-width row (beats inline/floats)
  function forceRow(li) {
    if (!li) return;
    li.classList.add('tmenu_item', 'tmenu_item_level_2');
    // Inline styles with !important to defeat upstream inline/float rules
    li.style.setProperty('display', 'block', 'important');
    li.style.setProperty('width', '100%', 'important');
    li.style.setProperty('float', 'none', 'important');
    li.style.setProperty('clear', 'both', 'important');
    li.style.setProperty('margin', '0', 'important');
    // Tighter vertical spacing between rows
    li.style.setProperty('margin-bottom', '0px', 'important');
  }

  // Make the anchor take the whole row width (prevents collapse) + set padding
  function forceFullWidthLink(a) {
    if (!a) return;
    a.classList.add('tmenu_item_link');
    a.style.setProperty('display', 'block', 'important');
    a.style.setProperty('width', '100%', 'important');
    // Set the requested vertical padding (5px) and keep horizontal at 8px
    a.style.setProperty('padding', '5px 8px', 'important');
  }

  function addViewAll(listEl, collection) {
    if (!ADD_VIEW_ALL) return;

    var li = document.createElement('li');
    forceRow(li); // ensure it’s its own row
    li.classList.add('qmm-view-all');

    var a = document.createElement('a');
    a.href = '/collections/' + collection;
    forceFullWidthLink(a);

    var span = document.createElement('span');
    span.className = 'tmenu_item_text';
    // keep label on one line
    span.style.setProperty('white-space', 'nowrap', 'important');
    span.innerHTML = VIEW_ALL_TEXT;

    a.appendChild(span);
    li.appendChild(a);
    listEl.appendChild(li);
  }

  function populate(listEl) {
    if (!listEl || filled.has(listEl)) return;
    filled.add(listEl);

    var collection = listEl.getAttribute('data-qmm-collection');
    var limit = parseInt(listEl.getAttribute('data-qmm-limit') || '8', 10);
    if (!collection) return;

    // UL baseline resets so theme can't make it flex/inline
    listEl.style.setProperty('list-style', 'none', 'important');
    listEl.style.setProperty('margin', '0', 'important');
    listEl.style.setProperty('padding', '0', 'important');
    listEl.style.setProperty('display', 'block', 'important');

    listEl.innerHTML = '';

    var url = '/collections/' + collection + '/products.json?limit=' + encodeURIComponent(limit);

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !Array.isArray(d.products) || !d.products.length) {
          var liEmpty = document.createElement('li');
          forceRow(liEmpty);
          var aEmpty = document.createElement('a');
          forceFullWidthLink(aEmpty);
          var spanEmpty = document.createElement('span');
          spanEmpty.className = 'tmenu_item_text';
          spanEmpty.textContent = 'No products found';
          aEmpty.appendChild(spanEmpty);
          liEmpty.appendChild(aEmpty);
          listEl.appendChild(liEmpty);
          return;
        }

        d.products.slice(0, limit).forEach(function (p) {
          if (!p || !p.handle) return;

          var li = document.createElement('li');
          forceRow(li);

          var a = document.createElement('a');
          a.href = '/products/' + p.handle;
          forceFullWidthLink(a);

          var span = document.createElement('span');
          span.className = 'tmenu_item_text';
          // Long names can wrap nicely
          span.style.setProperty('white-space', 'normal', 'important');
          span.style.setProperty('word-break', 'break-word', 'important');
          span.style.setProperty('overflow-wrap', 'anywhere', 'important');
          span.textContent = toTitleCase(p.title);

          a.appendChild(span);
          li.appendChild(a);
          listEl.appendChild(li);
        });

        addViewAll(listEl, collection);
      })
      .catch(function (err) {
        console.error('QMM dynamic list error:', err);
        var liErr = document.createElement('li');
        forceRow(liErr);
        var aErr = document.createElement('a');
        forceFullWidthLink(aErr);
        var spanErr = document.createElement('span');
        spanErr.className = 'tmenu_item_text';
        spanErr.textContent = 'Could not load products';
        aErr.appendChild(spanErr);
        liErr.appendChild(aErr);
        listEl.appendChild(liErr);
      });
  }

  function scanAndFill() {
    document.querySelectorAll('ul[data-qmm-featured-list]').forEach(populate);
  }

  document.addEventListener('DOMContentLoaded', scanAndFill);
  new MutationObserver(scanAndFill).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
